import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useDeleteReturnReason(shop: ShopDto) {
	return useApiMutation("delete", "/shops/{shopId}/reasons/{reasonId}", {
		invalidate: useInvalidateShop(shop.id),
		mapVariables: (reasonId: string) => ({
			params: { path: { shopId: shop?.id, reasonId } },
		}),
	});
}
